<template>
	<transition name="loader">
		<div class="loader-overlay" v-if="showLoader">
			<div class="loader"></div>
		</div>
	</transition>
</template>

<script>
	export default{
	  name: 'loader',

	  data () {
	    return {
	      showLoader: false
	    }
	  },

	  methods: {
	    onShow () {
	      this.showLoader = true
	    },

	    onClose () {
	      this.showLoader = false
	    }
	  }
	}
</script>



// WEBPACK FOOTER //
// Loader.vue?0d644f01